import React from 'react';
import ReactDOM from 'react-dom';
import { _T, C } from '../shared/theme';
import { s_PB, s_GB, s_GC } from '../shared/styles';
import { SEED_USERS, AI_PARTNER } from '../shared/constants';

function MultiplayerResults({lang, myScore, myLabel, partnerId, partnerScore, partnerLabel, aiComment, onClose, onRematch}) {
  const nl = lang==="nl";
  const partner = [...SEED_USERS, AI_PARTNER].find(u=>u.id===partnerId) || AI_PARTNER;
  const iWon = myScore > partnerScore;
  const tied = myScore === partnerScore;
  return ReactDOM.createPortal(
    <div style={{position:"fixed",inset:0,zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{position:"absolute",inset:0,background:"rgba(0,0,0,0.7)"}}/>
      <div className="popIn" style={{position:"relative",zIndex:301,background:_T.bg2,border:`1px solid ${_T.cardBorderTop}`,borderRadius:24,padding:28,maxWidth:360,width:"100%"}}>
        <div style={{textAlign:"center",marginBottom:20}}>
          <div style={{fontSize:48,marginBottom:8}}>{tied?"🤝":iWon?"🏆":"💪"}</div>
          <div style={{fontFamily:"Georgia,serif",fontSize:20,color:C.white}}>{tied?(nl?"Gelijkspel!":"Tied!"):(iWon?(nl?"Gewonnen!":"You Won!"):(nl?"Goed geprobeerd!":"Well Played!"))}</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
          <div style={{background:`${_T.accent}15`,border:`1px solid ${_T.accent}33`,borderRadius:14,padding:14,textAlign:"center"}}>
            <div style={{fontSize:11,color:C.silver,marginBottom:4}}>{nl?"Jij":"You"}</div>
            <div style={{fontSize:28,color:_T.accent,fontWeight:700}}>{myScore}</div>
            <div style={{fontSize:13,color:C.silver}}>{myLabel}</div>
          </div>
          <div style={{background:`${partner.color||"#7B6FD0"}15`,border:`1px solid ${partner.color||"#7B6FD0"}33`,borderRadius:14,padding:14,textAlign:"center"}}>
            <div style={{fontSize:11,color:C.silver,marginBottom:4}}>{partner.name}</div>
            <div style={{fontSize:28,color:partner.color||"#7B6FD0",fontWeight:700}}>{partnerScore}</div>
            <div style={{fontSize:13,color:C.silver}}>{partnerLabel}</div>
          </div>
        </div>
        {aiComment && (
          <div style={{...s_GC({padding:"12px 16px",marginBottom:16}),position:"relative",overflow:"hidden"}}>
            <div style={{fontSize:9,color:_T.accent,letterSpacing:3,fontWeight:600,marginBottom:6}}>🦋 COACH</div>
            <div style={{color:C.silver2,fontSize:13,lineHeight:1.6,fontStyle:"italic"}}>"{aiComment}"</div>
          </div>
        )}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <button style={s_GB({fontSize:13,padding:"11px"})} onClick={onClose}>{nl?"Klaar":"Done"}</button>
          <button style={s_PB({fontSize:13,padding:"11px"})} onClick={onRematch}>{nl?"Rematch":"Rematch"} 🔄</button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default MultiplayerResults;
